<script setup lang="ts">
import { computed } from 'vue'
import { uuid } from 'vue3-uuid'
import AccountCardSmall from '@/onenetwork/components/account_card/AccountCardSmall.vue'
import CsImage from '@/onenetwork/components/csimage/CsImage.vue'

interface Props {
  data: object | string | number,
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const data: any = computed(() => props.data as object)
</script>

<template>
  <!-- {{ data }} -->
  <div class="flash-offer-item">
    <div class="flash-offer-item__thumb">
      <cs-image :src="data.thumb" alt=""/>
      <div class="ribbon">#FO-{{ data.flash_offer_id }}</div>
    </div>
    <div class="flash-offer-item__info">
      <div class="flash-offer-item__info-address">{{ data.region }} - {{ data.address }}</div>
      <div class="flash-offer-item__info-name">{{ data.title }}</div>
      <div class="flash-offer-item__info-attrs">
        <div class="attrs" style="display: none">
          <div class="attr" v-for="(attr, idx) in props.data?.attrs" :key="`attr_item_${idx}_${uuid.v4().toString()}`">
            <span class="key">{{ attr.key }}</span>
            <span class="val">{{ attr.val }}</span>
          </div>
        </div>
        <div class="map">
          <div class="map_info_item">
            <span class="key">Số tờ</span>
            <span class="val">{{ props.data?.map?.map_sheet }}</span>
          </div>
          <div class="map_info_item">
            <span class="key">Số thửa</span>
            <span class="val">{{ props.data?.map?.plot_num }}</span>
          </div>
        </div>
      </div>
      <div class="flash-offer-item__info-acc grid grid-cols-2 w-full">
        <div class="col-span-1 w-full">
          <account-card-small :data="data.owner" class="customer" account-type="customer" v-if="data.owner" />
        </div>
        <div class="col-span-1 w-full">
          <account-card-small :data="data.broker" account-type="broker" v-if="data.broker" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
